import {
  QuestionScore,
  StudentActivityResponse,
  StudentScore,
} from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import { studentQuestionQuestionScore } from './studentQuestionQuestionScore';
import { studentQuestionResponseScore } from './studentQuestionResponseScore';

export const calculateStudentQuestionScore = (
  response: StudentActivityResponse,
  question: QuizQuestion,
  questionScore: QuestionScore,
  studentScore: StudentScore
) =>
  studentQuestionQuestionScore(studentScore) ??
  studentQuestionResponseScore(response, question, questionScore);
